/** @jsx jsx */

import { Fragment } from 'react';
import { isEmpty } from 'lodash';

import { Icon } from '@zapier/zinnia-icons';
import { Margin, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import StyleChecks from './StyleChecks';

import type { ImplementationValidationCheck } from 'app/developer-v3/types';

const Styles = {
  issuesSection: css`
    :not(:last-of-type) {
      margin-bottom: 20px;
    }
  `,
};

type Props = {
  errors: ImplementationValidationCheck;
  warnings?: ImplementationValidationCheck;
};

const ValidationChecks = ({ errors, warnings }: Props) => {
  const isValid = isEmpty(errors) && isEmpty(warnings);

  return isValid ? (
    <Fragment>
      <Margin margin="0px 0px 10px 0px">
        <Icon color="StatusSuccessWeaker" name="formCheckCircle" size="40" />
      </Margin>
      <Text fontWeight={600} type="Body1">
        No errors or warnings
      </Text>
    </Fragment>
  ) : (
    <Fragment>
      {isEmpty(errors) || (
        <section aria-label="Validation Errors" css={Styles.issuesSection}>
          <StyleChecks checks={errors} type="errors" />
        </section>
      )}
      {isEmpty(warnings) || (
        <section aria-label="Validation Warnings" css={Styles.issuesSection}>
          <StyleChecks checks={warnings} type="warnings" />
        </section>
      )}
    </Fragment>
  );
};

export default ValidationChecks;
